import * as Immutable from "immutable";
import { CHARACTER_LIMIT } from "constants/messages";

import { Features } from "resourceModels/Client";
import { getResource } from "selectors/resources";
import { removeTemplateVariables } from "services/strings";
import BaseMessageRecord, {
  BaseMessageRecordAttributes,
  BlockConfigGetter
} from "../BaseMessageRecord";

interface Attributes extends BaseMessageRecordAttributes {
  type: "zendesk_agent_workspace_handoff",
  fallbackResponseId: string,
  acknowledgementBody: string
}

class ZendeskAgentWorkspaceHandoffMessageRecord extends BaseMessageRecord<Attributes>({
  type: "zendesk_agent_workspace_handoff",
  fallbackResponseId: null,
  acknowledgementBody: "An agent will be with you as soon as they can. You’ll be notified here when the agent responds."
}) {
  static blockConfig: BlockConfigGetter = (state) => {
    const client = getResource(state, "client");
    const { platforms } = state;

    return {
      blockType: "action",
      isVisible: (
        client.hasFeature(Features.ZENDESK_AGENT_WORKSPACE) &&
        Boolean(platforms.getIn(["zaw_liveagent", "record", "enabled"]))
      ),
      blockName: "Zendesk Social Messaging",
      blockTitle: "Zendesk Social Messaging",
      shortTitle: "Zendesk Soci...",
      icon: "ZendeskSocialMessaging"
    };
  };
}

/**
 * Validation
 */

ZendeskAgentWorkspaceHandoffMessageRecord.getInvalidFields = (
  message: ZendeskAgentWorkspaceHandoffMessageRecord
): Immutable.List<string> => {
  const invalidFields: Set<string> = new Set();

  const bodyWithoutTemplateVars = removeTemplateVariables(message.acknowledgementBody);

  if (
    message.acknowledgementBody.trim().length <= 0 ||
    bodyWithoutTemplateVars.trim().length > CHARACTER_LIMIT
  ) {
    invalidFields.add("acknowledgementBody");
  }

  if (!message.acknowledgementBody) {
    invalidFields.add("acknowledgementBody");
  }

  if (!message.fallbackResponseId) {
    invalidFields.add("fallbackResponseId");
  }

  return Immutable.List(invalidFields);
};

export default ZendeskAgentWorkspaceHandoffMessageRecord;
